import genActTypes from '../core/types';

const types = genActTypes('categories');

export default types;
